import {createAction, handleActions} from 'redux-actions';
import {Map, List, fromJS/*, setIn*/} from 'immutable';
import {pender} from 'redux-pender';
import * as api from 'lib/api';

const GET_TODAY_LIST = 'finance/GET_TODAY_LIST';
const SET_LAST_THEMA = 'finance/SET_LAST_THEMA';

export const setIsLastThema = createAction(SET_LAST_THEMA);
export const getTodayList = createAction(GET_TODAY_LIST, api.getTodayList);

const initialState = Map({
  isLastThema : false,
  allList: List([
    // {"날짜":"20250602","오늘의키워드":"AI, SMR, 메디컬 에스테틱, 자율주행, 재생에너지, 수출, IPO"},
    // {"날짜":"20250515","오늘의키워드":"AI, SMR, 메디컬행, 재생에너지, 수출, IPO"}
  ]), 
  todayList: Map({
  //   "날짜": "20250602",
  //   "오늘의코멘트": "오늘은 AI, 메디컬 에스테틱, 원자력·SMR, 자율주행, 재생에너지 등 다수의 섹터에서 강한 상승 흐름이 관찰되었습니다. 특히 이재명 후보의 공약과 연계된 정책 테마와 AI 관련주들이 시장에서 주목받았습니다.",
  //   "오늘의키워드": "AI, SMR, 메디컬 에스테틱, 자율주행, 재생에너지, 수출, IPO",
  //   "테마목록": [
  //     {
  //       "테마": "🤖 AI 관련주",
  //       "테마내용": "생성형 AI 기술 확산 및 국내 AI 반도체 자립 기대감이 부각되며 관련 종목들이 급등세를 보였다.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주]웹케시, 이재명 후보 AI 육성·지역화폐 기대로 연일 강세",
  //           "뉴스주소": "https://n.news.naver.com/article/277/0005589220?sid=101"
  //         },
  //         {
  //           "뉴스제목": "[특징주] DSC인베스트먼트, 퓨리오사AI 국내 대기업에 AI반도체 공급 예고에 상승세",
  //           "뉴스주소": "https://m.etoday.co.kr/view.php?idxno=2474342"
  //         },
  //         {
  //           "뉴스제목": "유라클, 기존 8주 걸리던 항암제 예측 ‘1분만에’..LG AI연구원 협력 부각↑ [특징주]",
  //           "뉴스주소": "https://n.news.naver.com/article/014/0005358012?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "웹캐시",
  //           "현재가": "18160",
  //           "등락": "21.72",
  //           "거래량": "9118625"
  //         },
  //         {
  //           "종목명": "DSC인베스트먼트",
  //           "현재가": "6990",
  //           "등락": "11.13",
  //           "거래량": "9242503"
  //         },
  //         {
  //           "종목명": "유라클",
  //           "현재가": "24300",
  //           "등락": "29.95",
  //           "거래량": "3805766"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "💉 메디컬 에스테틱 / IPO",
  //       "테마내용": "자체 GMP 설비 기반 스킨부스터 및 필러 생산 기업인 바이오비쥬가 상장 첫날 따상에 근접하는 강세를 기록.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "바이오비쥬, 상장 첫날 공모가 대비 180%대↑…'따따블' 갈까[특징주]",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0006018733?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "바이오비쥬",
  //           "현재가": "19490",
  //           "등락": "16.78",
  //           "거래량": "12824843"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "⚛️ SMR·원자력",
  //       "테마내용": "SMR 밸류체인 진입 및 해외 수주 이력이 부각되며 태웅이 신고가를 경신.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주]태웅, SMR 부품 수주 기대감에 강세…신고가",
  //           "뉴스주소": "https://n.news.naver.com/article/277/0005600832?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "태웅",
  //           "현재가": "27500",
  //           "등락": "20.09",
  //           "거래량": "12164819"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🚘 자율주행 / 엔비디아",
  //       "테마내용": "세코닉스가 엔비디아의 자율주행 진출과 함께 전방 카메라 납품 이력이 부각되며 급등세.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주] 세코닉스, 엔비디아 자율주행 전방 카메라 납품...로보택시 진출 소식에 상승세",
  //           "뉴스주소": "https://m.etoday.co.kr/view.php?idxno=2475664"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "세코닉스",
  //           "현재가": "5960",
  //           "등락": "9.16",
  //           "거래량": "8202329"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🌞 재생에너지",
  //       "테마내용": "대선 후보의 재생에너지 산업 육성 공약에 따라 관련 기업들의 주가가 강세를 보임.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주] 재생에너지 대선 공약에…HD현대에너지솔루션 19% 급등",
  //           "뉴스주소": "https://n.news.naver.com/article/119/0002963244?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "HD현대에너지솔루션",
  //           "현재가": "52200",
  //           "등락": "8.19",
  //           "거래량": "3519906"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "📦 화장품 수출",
  //       "테마내용": "5월 화장품 수출이 역대 최대치를 기록하며 관련 종목이 강세.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "“5월 화장품 수출 역대 최대”…실리콘투, 6%대↑[특징주]",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0006029490?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "실리콘투",
  //           "현재가": "51500",
  //           "등락": "9.11",
  //           "거래량": "5513809"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "📈 실적 개선",
  //       "테마내용": "생산성 향상과 비용절감으로 실적이 급증하며 투자자들의 주목을 받음.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주]아모센스, 지난해 영업익 800% 증가에 ‘上’",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0005938507?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "아모센스",
  //           "현재가": "7380",
  //           "등락": "29.93",
  //           "거래량": "4134565"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🎬 콘텐츠 플랫폼 기대감",
  //       "테마내용": "넷플릭스 앱 내 네이버웹툰 탑재 가능성 언급으로 관련주들이 강세를 보임.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "'넷플릭스 웹툰 탑재' 기대에 관련주 들썩…미스터블루 19%↑[특징주]",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0006029489?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "미스터블루",
  //           "현재가": "1577",
  //           "등락": "18.84",
  //           "거래량": "66090353"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🌍 해외 진출 소비재",
  //       "테마내용": "글로벌 유통망 확대와 마케팅 강화 전략에 따라 소비재 브랜드가 강세.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "브이티, 리들샷 글로벌 진출 본격화에 ‘52주 신고가’[특징주]",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0006024676?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "브이티",
  //           "현재가": "44200",
  //           "등락": "8.33",
  //           "거래량": "1801858"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🇸🇦 중동 진출 의료기기",
  //       "테마내용": "브이 레이저가 사우디 인증을 획득하며 중동 헬스케어 시장 진출 기대감이 반영.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "[특징주] 원텍 급등, “브이 레이저 사우디 인증 획득” 중동 최대 헬스케어 시장 ‘정조준’",
  //           "뉴스주소": "https://n.news.naver.com/article/018/0005938507?sid=101"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "원텍",
  //           "현재가": "10270",
  //           "등락": "10.43",
  //           "거래량": "5609607"
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🗳️ 정치 테마주",
  //       "테마내용": "대선 후보 관련 여론조사 결과와 공약 수혜 기대감으로 정치 테마주들이 강세.",
  //       "테마관련기사들": [
  //         {
  //           "뉴스제목": "이재명 49% 김문수 27% 이준석 7%…“정권 교체” 57%",
  //           "뉴스주소": "https://www.donga.com/news/Politics/article/all/20250515/131611731/2"
  //         }
  //       ],
  //       "테마종목들": [
  //         {
  //           "종목명": "포바이포",
  //           "현재가": "19620",
  //           "등락": "8.22",
  //           "거래량": "2796262"
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   "날짜": "20250515",
  //   "오늘의코멘트": "오늘은 AI, 바이오, 핀테크 등 기술 중심의 미래 산업 섹터에 시장의 관심이 집중된 하루였습니다. 특히 장기적 성장성을 주목받는 테마에 강한 수급이 유입되며 주가가 상승세를 보였습니다. 로봇, 신약개발, 인터넷은행 등은 정책 기대감과 실적 성장 스토리가 동시에 부각되며 힘을 받았습니다.",
  //   "오늘의키워드": "바이오, AI신약개발, 로봇, 핀테크, 인터넷은행",
  //   "테마목록": [
  //     {
  //       "테마": "🧬 바이오/장기연구",
  //       "테마내용": "오늘 바이오주는 장기적인 헬스케어 기술 개발과 관련된 긍정적인 기사들이 이어지며 강세를 보였습니다. 조직재생, 줄기세포 치료, 개인 맞춤형 의료 등 미래 의료기술을 겨냥한 기업들에 대한 투자 심리가 개선되었으며, 특히 재생의학과 바이오소재 기술에 기반한 기업들이 주목받았습니다.",
  //       "테마종목들": [
  //         {
  //           "종목명": "로킷헬스케어",
  //           "현재가": "",
  //           "등락": "23.4",
  //           "거래량": "220003"
  //         },
  //         {
  //           "종목명": "상보",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "프롬바이오",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "🤖 로봇/협동로봇",
  //       "테마내용": "로봇 산업은 제조업 자동화 수요 증가와 정부의 정책적 지원 확대에 힘입어 관심이 이어지고 있습니다. 특히 협동로봇은 사람과 함께 작업할 수 있는 안전성과 효율성으로 산업 전반에 빠르게 확산 중이며, 실증사업 및 수출 확대 뉴스도 주가 상승에 영향을 주었습니다.",
  //       "테마종목들": [
  //         {
  //           "종목명": "DS한국",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "국일신동",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "휴림로봇",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "HPSP",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "💊 AI 신약개발",
  //       "테마내용": "AI 기술을 활용한 신약개발 시장이 빠르게 성장하고 있으며, 특히 임상시험 데이터 분석과 후보물질 발굴 효율화에 강점을 가진 기업들이 각광받고 있습니다. 신약 개발 속도를 획기적으로 높일 수 있는 가능성으로 인해 투자자들의 기대감이 확대되는 모습입니다.",
  //       "테마종목들": [
  //         {
  //           "종목명": "바이오스마트",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "덱스터",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "애니젠",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         }
  //       ]
  //     },
  //     {
  //       "테마": "💳 인터넷은행/핀테크",
  //       "테마내용": "금융산업의 디지털 전환이 가속화되면서 인터넷은행 및 핀테크 관련 종목들이 상승세를 보였습니다. 간편결제, 온라인 대출, B2B 핀테크 솔루션 등 다양한 신사업 모델이 주목받고 있으며, 정부의 규제 완화 기대감도 긍정적으로 작용하고 있습니다.",
  //       "테마종목들": [
  //         {
  //           "종목명": "펌텍코리아",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "윈스",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         },
  //         {
  //           "종목명": "와이아이케이",
  //           "현재가": "",
  //           "등락": "",
  //           "거래량": ""
  //         }
  //       ]
  //     }
  //   ]
  })
});

export default handleActions({
  [SET_LAST_THEMA]: (state, action) => {
    const isLastThema = state.getIn(['isLastThema']);
    return state.setIn(['isLastThema'], !isLastThema);
  },
  ...pender({
    type: GET_TODAY_LIST,
    onSuccess: (state, action) => {
      // const id = state.getIn(['itemFilters', 'itemKind']);
      const {result1, result2} = action.payload.data;
      
      return state.setIn(['todayList'], fromJS(result1))
                  .setIn(['allList'], fromJS(result2));
    }
  })

}, initialState);